import React from 'react';
export const AboutSection = () => {
  return <section id="about" className="w-full bg-[#0f0f0f] py-24" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8" data-id="element-22">
          <div className="md:col-span-10 md:col-start-2" data-id="element-23">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-red-600 tracking-tight" data-id="element-24">
              About Binary Solutions <span className="text-white" data-id="element-25">101010</span>
            </h2>
            <div className="w-32 h-1.5 bg-[#e11d48] mb-10" data-id="element-26"></div>
            <p className="text-gray-200 text-lg md:text-xl mb-8 leading-relaxed" data-id="element-27">
              Binary Solutions 101010 is a forward-thinking South African IT
              company driven by precision, security, and smart technology. We
              specialize in developing custom software, responsive websites, and
              intelligent security systems that solve real-world challenges.
            </p>
            <p className="text-gray-200 text-lg md:text-xl mb-8 leading-relaxed" data-id="element-28">
              Our work combines strategy, beautiful design, and scalable code to
              create solutions that empower startups, businesses, and government
              clients alike. From powerful mobile apps and customer portals to
              biometric access control and AI-powered surveillance systems — we
              don't just build products, we build digital trust.
            </p>
            <p className="text-gray-200 text-lg md:text-xl mb-10 leading-relaxed" data-id="element-29">
              Whether you're looking to automate processes, enhance digital
              security, or launch your next app, our team is ready to turn your
              vision into code.
            </p>
            <blockquote className="border-l-4 border-[#e11d48] pl-6 py-3 mb-6" aria-label="Company quote" data-id="element-30">
              <p className="text-white italic font-medium text-xl md:text-2xl" data-id="element-31">
                "101010 isn't just a name — it's a symbol of digital
                transformation."
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
};